var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-3 pr-1" }, [
        _c(
          "div",
          { staticClass: "card table-scroll height-responsive-filtre-100" },
          [
            _c("div", { staticClass: "card-header" }, [_vm._v(" Filtres ")]),
            _c("div", { staticClass: "table-body" }, [
              _c("table", { staticClass: "table table-sm table-borderless" }, [
                _c(
                  "tbody",
                  [
                    _vm._m(0),
                    _vm._l(_vm.categories, function(categorie, iCat) {
                      return [
                        _c(
                          "tr",
                          {
                            key: "cat" + iCat,
                            staticStyle: {
                              position: "sticky",
                              top: "26px",
                              background: "white"
                            }
                          },
                          [
                            _c("td", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "label-checkbox mt-1" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: categorie.checked,
                                        expression: "categorie.checked"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(categorie.checked)
                                        ? _vm._i(categorie.checked, null) > -1
                                        : categorie.checked
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = categorie.checked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  categorie,
                                                  "checked",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  categorie,
                                                  "checked",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(categorie, "checked", $$c)
                                          }
                                        },
                                        function($event) {
                                          return _vm.getfilteredDataCategories(
                                            categorie
                                          )
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(categorie[0]) + " ")
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._l(categorie[1], function(categorieItem, iSousCat) {
                          return _c(
                            "tr",
                            { key: "cat" + iCat + "sousCat" + iSousCat },
                            [
                              _c("td", { staticClass: "pl-4" }, [
                                _c(
                                  "label",
                                  { staticClass: "label-checkbox mt-1" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: categorieItem.checked,
                                          expression: "categorieItem.checked"
                                        }
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          categorieItem.checked
                                        )
                                          ? _vm._i(
                                              categorieItem.checked,
                                              null
                                            ) > -1
                                          : categorieItem.checked
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$a = categorieItem.checked,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    categorieItem,
                                                    "checked",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    categorieItem,
                                                    "checked",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                categorieItem,
                                                "checked",
                                                $$c
                                              )
                                            }
                                          },
                                          function($event) {
                                            return _vm.getfilteredDataCategories(
                                              categorieItem
                                            )
                                          }
                                        ]
                                      }
                                    }),
                                    _vm._v(
                                      " " + _vm._s(categorieItem.nom) + " "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        })
                      ]
                    }),
                    _vm._m(1),
                    _vm._l(_vm.composantes, function(composante) {
                      return _vm._l(composante[1], function(composanteItem, i) {
                        return _c(
                          "tr",
                          {
                            key: "comp" + i,
                            staticStyle: {
                              position: "sticky",
                              top: "26px",
                              background: "white"
                            }
                          },
                          [
                            _c("td", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "label-checkbox mt-1" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: composanteItem.checked,
                                        expression: "composanteItem.checked"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        composanteItem.checked
                                      )
                                        ? _vm._i(composanteItem.checked, null) >
                                          -1
                                        : composanteItem.checked
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = composanteItem.checked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  composanteItem,
                                                  "checked",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  composanteItem,
                                                  "checked",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              composanteItem,
                                              "checked",
                                              $$c
                                            )
                                          }
                                        },
                                        _vm.getfilteredDataComposantes
                                      ]
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(composanteItem.nom) + " ")
                                ]
                              )
                            ])
                          ]
                        )
                      })
                    }),
                    _vm._m(2),
                    _vm._l(_vm.regimesSelect, function(regime) {
                      return _vm._l(regime[1], function(regimeItem, i) {
                        return _c(
                          "tr",
                          {
                            key: "reg" + i,
                            staticStyle: {
                              position: "sticky",
                              top: "26px",
                              background: "white"
                            }
                          },
                          [
                            _c("td", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "label-checkbox mt-1" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: regimeItem.checked,
                                        expression: "regimeItem.checked"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(regimeItem.checked)
                                        ? _vm._i(regimeItem.checked, null) > -1
                                        : regimeItem.checked
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = regimeItem.checked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  regimeItem,
                                                  "checked",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  regimeItem,
                                                  "checked",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(regimeItem, "checked", $$c)
                                          }
                                        },
                                        _vm.getfilteredDataRegimes
                                      ]
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(regimeItem.nom) + " ")
                                ]
                              )
                            ])
                          ]
                        )
                      })
                    }),
                    _vm._m(3),
                    _vm._l(_vm.texturesSelect, function(texture) {
                      return _vm._l(texture[1], function(textureItem, i) {
                        return _c(
                          "tr",
                          {
                            key: "text" + i,
                            staticStyle: {
                              position: "sticky",
                              top: "26px",
                              background: "white"
                            }
                          },
                          [
                            _c("td", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "label-checkbox mt-1" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: textureItem.checked,
                                        expression: "textureItem.checked"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        textureItem.checked
                                      )
                                        ? _vm._i(textureItem.checked, null) > -1
                                        : textureItem.checked
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = textureItem.checked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  textureItem,
                                                  "checked",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  textureItem,
                                                  "checked",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              textureItem,
                                              "checked",
                                              $$c
                                            )
                                          }
                                        },
                                        _vm.getfilteredDataTextures
                                      ]
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(textureItem.nom) + " ")
                                ]
                              )
                            ])
                          ]
                        )
                      })
                    }),
                    _vm._m(4),
                    _vm._l(_vm.categoriesGEMRCNSelect, function(
                      categorieGEMRCN
                    ) {
                      return _vm._l(categorieGEMRCN[1], function(
                        categorieGEMRCNItem,
                        i
                      ) {
                        return _c(
                          "tr",
                          {
                            key: "gemrcn" + i,
                            staticStyle: {
                              position: "sticky",
                              top: "26px",
                              background: "white"
                            }
                          },
                          [
                            _c("td", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { staticClass: "label-checkbox mt-1" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: categorieGEMRCNItem.checked,
                                        expression:
                                          "categorieGEMRCNItem.checked"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        categorieGEMRCNItem.checked
                                      )
                                        ? _vm._i(
                                            categorieGEMRCNItem.checked,
                                            null
                                          ) > -1
                                        : categorieGEMRCNItem.checked
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = categorieGEMRCNItem.checked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  categorieGEMRCNItem,
                                                  "checked",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  categorieGEMRCNItem,
                                                  "checked",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              categorieGEMRCNItem,
                                              "checked",
                                              $$c
                                            )
                                          }
                                        },
                                        _vm.getFilteredDataCategoriesGEMRCN
                                      ]
                                    }
                                  }),
                                  _vm._v(
                                    " " + _vm._s(categorieGEMRCNItem.nom) + " "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      })
                    })
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "col-4 pl-1 pr-1" }, [
        _c(
          "div",
          { staticClass: "card table-scroll height-responsive-filtre-100" },
          [
            _c(
              "div",
              { staticClass: "card-header flex-center-space-between" },
              [
                _vm._v(" Recettes "),
                _c("div", { staticClass: "flex-center-space-between" }, [
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: _vm.detailsSwitch("personnelles") },
                        expression: "{ content: detailsSwitch('personnelles') }"
                      }
                    ],
                    staticClass: "fas fa-user cursor-pointer",
                    class:
                      _vm.typeDeRecherche === "personnelles" ? "selected" : "",
                    staticStyle: {
                      "font-size": "1.2rem",
                      color: "rgba(255, 255, 255, 0.4)"
                    },
                    attrs: { id: "rdbUser" },
                    on: {
                      click: function($event) {
                        return _vm.switchType("personnelles")
                      }
                    }
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: _vm.detailsSwitch("etablissement") },
                        expression:
                          "{ content: detailsSwitch('etablissement') }"
                      }
                    ],
                    staticClass: "far fa-building cursor-pointer",
                    class:
                      _vm.typeDeRecherche === "etablissement" ? "selected" : "",
                    staticStyle: {
                      "margin-left": "1rem",
                      "font-size": "1.2rem",
                      color: "rgba(255, 255, 255, 0.4)"
                    },
                    attrs: { id: "rdbEtab" },
                    on: {
                      click: function($event) {
                        return _vm.switchType("etablissement")
                      }
                    }
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: _vm.detailsSwitch("universelles") },
                        expression: "{ content: detailsSwitch('universelles') }"
                      }
                    ],
                    staticClass: "fas fa-globe cursor-pointer",
                    class:
                      _vm.typeDeRecherche === "universelles" ? "selected" : "",
                    staticStyle: {
                      "margin-left": "1rem",
                      "font-size": "1.4rem",
                      display: "flex",
                      color: "rgba(255, 255, 255, 0.4)"
                    },
                    attrs: { id: "rdbUniv" },
                    on: {
                      click: function($event) {
                        return _vm.switchType("universelles")
                      }
                    }
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: _vm.detailsSwitch("toutes") },
                        expression: "{ content: detailsSwitch('toutes') }"
                      }
                    ],
                    staticClass: "fas fa-infinity cursor-pointer",
                    class: _vm.typeDeRecherche === "toutes" ? "selected" : "",
                    staticStyle: {
                      "margin-left": "1rem",
                      "font-size": "1.2rem",
                      display: "flex",
                      color: "rgba(255, 255, 255, 0.4)"
                    },
                    attrs: { id: "rdbUniv" },
                    on: {
                      click: function($event) {
                        return _vm.switchType("toutes")
                      }
                    }
                  })
                ]),
                _vm.allowMultiAction
                  ? _c("span", [
                      _c(
                        "label",
                        { staticClass: "label-checkbox mt-1" },
                        [
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v("Multi")
                          ]),
                          _c("ToggleButton", {
                            staticClass: "ml-2 mt-1",
                            attrs: {
                              color: {
                                checked: "#16D39A",
                                unchecked: "#CCCCCC"
                              },
                              height: 12,
                              width: 20
                            },
                            model: {
                              value: _vm.enableMulti,
                              callback: function($$v) {
                                _vm.enableMulti = $$v
                              },
                              expression: "enableMulti"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm.$route.name !== "Menus" &&
                (_vm.profilIsUtilisateur || _vm.profilIsAdmin)
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn btn-success btn-sm",
                        staticStyle: { "margin-left": "6px" },
                        attrs: { disabled: _vm.enableMulti, alt: "Nouvelle" },
                        on: {
                          click: function($event) {
                            return _vm.nouvelleRecette()
                          }
                        }
                      },
                      [_vm._v("Nouvelle")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm.listeDesRecettes
              ? _c(
                  "table",
                  {
                    ref: "listeRecettes",
                    staticClass: "table table-sm table-borderless m-0 p-0"
                  },
                  [
                    _c("thead", [
                      _c(
                        "th",
                        { staticClass: "p-0" },
                        [
                          _c("VueFuse", {
                            staticClass: "p-0",
                            attrs: {
                              placeholder: _vm.compTermeDeRecherche,
                              list: _vm.list,
                              keys: ["nom"],
                              search: _vm.termeDeRecherche
                            },
                            on: {
                              "fuse-input-changed": _vm.getTermeDeRecherche,
                              "fuse-results-updated": _vm.retourRecherche,
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.currentItem = 0
                              }
                            }
                          }),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _vm.termeDeRecherche
                                ? _c("span", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: "Effacer la recherche"
                                        },
                                        expression:
                                          "{ content: 'Effacer la recherche'}"
                                      }
                                    ],
                                    staticClass:
                                      "fas fa-window-close mt-1 pt-3",
                                    on: {
                                      click: function($event) {
                                        return _vm.effacerLaRecherche()
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "table-body" }, [
              _c("table", { staticClass: "table table-sm table-borderless" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.listeDesRecettes, function(recetteInList, i) {
                    return _c(
                      "tr",
                      {
                        key: i,
                        class: {
                          "active-item_recetteliste":
                            (_vm.enableMulti &&
                              _vm.selectedMulti.indexOf(recetteInList.id) >
                                -1) ||
                            (!_vm.enableMulti && _vm.currentItem === i)
                        },
                        on: {
                          keyup: _vm.nextItem,
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.currentRecette(i)
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "pl-4 pr-4 flex-center-space-between"
                          },
                          [
                            _c("div", [
                              _vm.enableMulti &&
                              _vm.selectedMulti.indexOf(recetteInList.id) === -1
                                ? _c("i", {
                                    staticClass: "fas fa-square",
                                    staticStyle: { "margin-right": "10px" }
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              _vm.selectedMulti.indexOf(recetteInList.id) > -1
                                ? _c("i", {
                                    staticClass: "fas fa-check-square",
                                    staticStyle: { "margin-right": "10px" }
                                  })
                                : _vm._e(),
                              recetteInList.estPerso
                                ? _c("i", {
                                    staticClass: "fas fa-user push-right-1rem"
                                  })
                                : _vm._e(),
                              recetteInList.estEtab
                                ? _c("i", {
                                    staticClass:
                                      "far fa-building push-right-1rem"
                                  })
                                : _vm._e(),
                              recetteInList.estDeclinaisonPersonnalisee
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem"
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              recetteInList.categorieValideeEnMasse
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem",
                                    staticStyle: { color: "blue" }
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              recetteInList.zonePreparationValideeEnMasse
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem",
                                    staticStyle: { color: "pink" }
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              recetteInList.texturesValideesEnMasse
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem",
                                    staticStyle: { color: "yellow" }
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              recetteInList.regimesValidesEnMasse
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem",
                                    staticStyle: { color: "green" }
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              recetteInList.composantesValideesEnMasse
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem",
                                    staticStyle: { color: "orange" }
                                  })
                                : _vm._e(),
                              _vm.enableMulti &&
                              recetteInList.categoriesGEMRCNValideesEnMasse
                                ? _c("i", {
                                    staticClass: "fas fa-check push-right-1rem",
                                    staticStyle: { color: "brown" }
                                  })
                                : _vm._e(),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    recetteInList.nom.charAt(0).toUpperCase() +
                                      recetteInList.nom.slice(1)
                                  ) +
                                  " "
                              )
                            ]),
                            _vm.menu &&
                            _vm.menu.menuSurPlanAlimentaire &&
                            _vm.nbUtilisationsRecette(recetteInList)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bg-white border border-dark",
                                    staticStyle: {
                                      "font-size": "12px",
                                      height: "18px",
                                      width: "50px",
                                      right: "0",
                                      "border-radius": "5px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "PA : " +
                                        _vm._s(
                                          _vm.nbUtilisationsRecette(
                                            recetteInList
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "col-5 pl-1" }, [
        _c("div", { staticClass: "card" }, [
          _vm.enableMulti
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "card-header flex-center-space-between" },
                  [
                    _vm.selectedMulti.length === 0
                      ? [_vm._v("VEUILLEZ SELECTIONNER DES RECETTES")]
                      : [
                          _vm._v(
                            "ACTIONS " +
                              _vm._s(
                                _vm.selectedMulti.length > 1 ? "EN MASSE " : ""
                              ) +
                              "SUR " +
                              _vm._s(_vm.selectedMulti.length) +
                              " RECETTE" +
                              _vm._s(_vm.selectedMulti.length > 1 ? "S" : "")
                          )
                        ]
                  ],
                  2
                ),
                _c("div", { staticClass: "card-body" }, [
                  _vm.selectedMulti.length === 0
                    ? _c("div", { staticClass: "card-body" }, [
                        _vm._v(
                          " Utilisez la colonne centrale pour sélectionner des recettes "
                        )
                      ])
                    : _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "p-2",
                              staticStyle: { border: "1px solid blue" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "10px!important",
                                    color: "rgba(0,0,0,.54)",
                                    "margin-bottom": "2px"
                                  }
                                },
                                [_vm._v("Catégorie")]
                              ),
                              _c(
                                "b-form-select",
                                {
                                  attrs: {
                                    options: _vm.categorieRecettes,
                                    "text-field": "text",
                                    "value-field": "value"
                                  },
                                  model: {
                                    value: _vm.changesMulti.categorieRecetteId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.changesMulti,
                                        "categorieRecetteId",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression:
                                      "changesMulti.categorieRecetteId"
                                  }
                                },
                                [
                                  _c("template", { slot: "first" }, [
                                    _c(
                                      "option",
                                      {
                                        attrs: { selected: "" },
                                        domProps: { value: null }
                                      },
                                      [_vm._v("Catégorie...")]
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "p-2 mt-3",
                              staticStyle: { border: "1px solid pink" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "10px!important",
                                    color: "rgba(0,0,0,.54)",
                                    "margin-bottom": "2px"
                                  }
                                },
                                [_vm._v("Zone de préparation")]
                              ),
                              _c(
                                "b-form-select",
                                {
                                  attrs: {
                                    options: _vm.zonesPreparations,
                                    "text-field": "text",
                                    "value-field": "value"
                                  },
                                  model: {
                                    value: _vm.changesMulti.zonePreparationId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.changesMulti,
                                        "zonePreparationId",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "changesMulti.zonePreparationId"
                                  }
                                },
                                [
                                  _c("template", { slot: "first" }, [
                                    _c(
                                      "option",
                                      {
                                        attrs: { selected: "" },
                                        domProps: { value: null }
                                      },
                                      [_vm._v("Zone de préparation...")]
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "p-2 mt-3",
                              staticStyle: { border: "1px solid yellow" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "10px!important",
                                    color: "rgba(0,0,0,.54)",
                                    "margin-bottom": "2px"
                                  }
                                },
                                [_vm._v("Textures incompatibles")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  value: _vm.changesMulti.textureIds,
                                  items: _vm.texturesPourExclusion,
                                  placeholder: "Textures...",
                                  emptyText:
                                    "Toutes les textures ont été ajoutées"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.changesMulti.textureIds = $event
                                    _vm.changesMulti.aucuneTextureIncompatible = false
                                  }
                                }
                              }),
                              _c("input", {
                                staticClass: "form-check-input ml-0",
                                attrs: {
                                  type: "checkbox",
                                  id: "aucuneTextureIncompatible"
                                },
                                domProps: {
                                  checked:
                                    _vm.changesMulti.aucuneTextureIncompatible
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.setAucuneTextureIncompatible(
                                      $event.currentTarget.checked
                                    )
                                  }
                                }
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label ml-4",
                                  attrs: { for: "aucuneTextureIncompatible" }
                                },
                                [_vm._v("Aucune incompatibilité ?")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "p-2 mt-3",
                              staticStyle: { border: "1px solid green" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "10px!important",
                                    color: "rgba(0,0,0,.54)",
                                    "margin-bottom": "2px"
                                  }
                                },
                                [_vm._v("Régimes alimentaires incompatibles")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  value: _vm.changesMulti.regimeIds,
                                  items: _vm.regimesPourExclusion,
                                  placeholder: "Régimes alimentaires...",
                                  emptyText: "Tous les régimes ont été ajoutés"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.changesMulti.regimeIds = $event
                                    _vm.changesMulti.aucunRegimeIncompatible = false
                                  }
                                }
                              }),
                              _c("input", {
                                staticClass: "form-check-input ml-0",
                                attrs: {
                                  type: "checkbox",
                                  id: "aucunRegimeIncompatible"
                                },
                                domProps: {
                                  checked:
                                    _vm.changesMulti.aucunRegimeIncompatible
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.setAucunRegimeIncompatible(
                                      $event.currentTarget.checked
                                    )
                                  }
                                }
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label ml-4",
                                  attrs: { for: "aucunRegimeIncompatible" }
                                },
                                [_vm._v("Aucune incompatibilité ?")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "p-2 mt-3",
                              staticStyle: { border: "1px solid orange" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "10px!important",
                                    color: "rgba(0,0,0,.54)",
                                    "margin-bottom": "2px"
                                  }
                                },
                                [_vm._v("Composantes de repas")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  value: _vm.changesMulti.composanteMenuIds,
                                  items: _vm.composantesRepas,
                                  placeholder: "Composantes...",
                                  emptyText:
                                    "Toutes les composantes ont été ajoutées"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.changesMulti.composanteMenuIds = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "p-2 mt-3",
                              staticStyle: { border: "1px solid brown" }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    "font-size": "10px!important",
                                    color: "rgba(0,0,0,.54)",
                                    "margin-bottom": "2px"
                                  }
                                },
                                [_vm._v("Catégories GEMRCN")]
                              ),
                              _c("MultiSelect", {
                                attrs: {
                                  value: _vm.changesMulti.gemrcnIds,
                                  items: _vm.gemrcn,
                                  placeholder: "Catégories GEMRCN...",
                                  emptyText:
                                    "Toutes les catégories ont été ajoutées"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.changesMulti.gemrcnIds = $event
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-success",
                              staticStyle: { "margin-top": "20px" },
                              attrs: { alt: "Enregistrer" },
                              on: {
                                click: function($event) {
                                  return _vm.enregistrerMulti()
                                }
                              }
                            },
                            [_vm._v("Enregistrer")]
                          )
                        ],
                        1
                      )
                ]),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _vm.selectedMulti.length === 0
                        ? _c("h4", [_vm._v("Aucune recette sélectionnée")])
                        : _c("h4", [
                            _vm._v(
                              "Recette" +
                                _vm._s(
                                  _vm.selectedMulti.length > 1 ? "s" : ""
                                ) +
                                " sélectionnée" +
                                _vm._s(_vm.selectedMulti.length > 1 ? "s" : "")
                            )
                          ]),
                      _vm._l(_vm.selectedMulti, function(id) {
                        return _c(
                          "div",
                          { key: id, staticClass: "flex-center-space-between" },
                          [
                            _c("div", [_vm._v(_vm._s(_vm.nomRecette(id)))]),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: {
                                      content:
                                        "Retirer ''" +
                                        _vm.nomRecette(id) +
                                        "'' de la sélection"
                                    },
                                    expression:
                                      "{ content: 'Retirer \\'\\'' + nomRecette(id) + '\\'\\' de la sélection'}"
                                  }
                                ],
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleRecetteMulti(id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-times" })]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            : !_vm.pasDeRecette
            ? _c(
                "div",
                [
                  _vm.menuExpanded
                    ? _c("RecetteApercu", {
                        attrs: {
                          recette: _vm.recette,
                          composanteEffectif: _vm.composanteEffectif,
                          destination: {
                            composanteId: _vm.composanteId,
                            serviceId: _vm.serviceId,
                            cleComposee: _vm.cleComposee
                          }
                        },
                        on: {
                          "recette-supprimee": function($event) {
                            return _vm.rechargerListe()
                          }
                        }
                      })
                    : _c("RecetteApercu", {
                        attrs: {
                          recette: _vm.recette,
                          composanteEffectif: _vm.composanteEffectif,
                          destination: {
                            composanteId: _vm.composanteId,
                            serviceId: _vm.serviceId,
                            cleComposee: _vm.cleComposee
                          }
                        },
                        on: {
                          "recette-supprimee": function($event) {
                            return _vm.rechargerListe()
                          }
                        }
                      })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass: "table-header-secondary",
        staticStyle: { position: "sticky", top: "0" }
      },
      [_c("td", [_vm._v("Catégories")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass: "table-header-secondary",
        staticStyle: { position: "sticky", top: "0" }
      },
      [_c("td", [_vm._v("Composantes")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass: "table-header-secondary",
        staticStyle: { position: "sticky", top: "0" }
      },
      [_c("td", [_vm._v("Régimes")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass: "table-header-secondary",
        staticStyle: { position: "sticky", top: "0" }
      },
      [_c("td", [_vm._v("Textures")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass: "table-header-secondary",
        staticStyle: { position: "sticky", top: "0" }
      },
      [_c("td", [_vm._v("Catégories GEMRCN")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }